// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header--Sdz_S","content":"Header-module__content--jYBUU"};